import { brandConfig } from 'config/brand';

const Logo = ({ width = 150, height = 'auto', alt = 'company logo', fit = 'contain', style = {}, ...props }) => {
    return (
        <img
            src={brandConfig.logo}
            alt={alt}
            style={{
                width,
                height,
                objectFit: fit,
                display: 'block',
                ...style
            }}
            {...props}
        />
    );
};

export default Logo;
